import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { ESPORTS_POST_QUERY } from '../../gql/queries/esports-post';
import { ogCoverUrl } from 'embroil/helpers/cover-url';
import { service } from '@ember/service';

export default class Tournament extends Route {
  @service head;

  async model({ slug }) {
    this.query = useQuery(this, () => [
      ESPORTS_POST_QUERY,
      {
        variables: { slug },
      },
    ]);
    await this.query.promise;
    const mod = this.query.data;
    // New GraphQL API returns direct object, not collection/items structure
    return mod.article;
  }

  afterModel(model) {
    if (model) {
      this.head.updateMeta({
        title: model.title,
        description: model.shortDescription,
        ogTitle: model.title,
        ogDescription: model.shortDescription,
        ogImage: ogCoverUrl(model),
        ogType: 'article',
        canonical: `https://1vX.gg/esports/news/${model.slug}`
      });
    }
  }
}
